import { integrationsEnabled, integrationsRequest } from '../lib/integrations';

export const newTicketSession = (type = 'bug') => ({ id: crypto.randomUUID(), type, answers: {}, step: 0, draft: null, published: null });
const keyFor = userId => `spcc:user:${userId}:ticket-writer`;
export function loadTicketSession(userId) {
  try {
    const saved = JSON.parse(localStorage.getItem(keyFor(userId)) || 'null');
    if (saved && typeof saved.id === 'string' && ['bug', 'epic', 'initiative', 'prd'].includes(saved.type) && saved.answers && typeof saved.answers === 'object' && Number.isInteger(saved.step) && saved.step >= 0 && saved.step <= 4) return saved;
  } catch { /* A damaged draft should not prevent opening the writer. */ }
  return newTicketSession();
}
export function saveTicketSession(userId, session) {
  if (!userId) throw new Error('Sign in to save your draft.');
  localStorage.setItem(keyFor(userId), JSON.stringify(session));
}

// Provider-neutral interface. The server owns credentials and destination adapters.
export const getTicketDestinations = async () => integrationsEnabled
  ? (await integrationsRequest('/api/tickets/destinations')).destinations : [];
const destinationRequest = (provider, action, body, signal) => integrationsRequest(`/api/tickets/${encodeURIComponent(provider)}/${action}`, { body, signal });
export const getTicketProjects = (provider, siteId, signal) => destinationRequest(provider, 'projects', { site_id: siteId }, signal);
export const getTicketIssueTypes = (provider, siteId, projectId, signal) => destinationRequest(provider, 'issue-types', { site_id: siteId, project_id: projectId }, signal);
export const getTicketFields = (provider, siteId, projectId, issueTypeId, signal) => destinationRequest(provider, 'fields', { site_id: siteId, project_id: projectId, issue_type_id: issueTypeId }, signal);
export const publishTicket = (provider, body) => destinationRequest(provider, 'publish', body);
